export const sortNamespace = (metafields) => {
  const source = Object.assign(metafields)

  return Object.keys(source).reduce((rows, key) => {
    const values = source[key]
    return values.map((value, i) => Object.assign(rows[i] || {}, { [key]: value }))
  }, [])
}
